import MethodDetailModal from './MethodDetailModal';

export default MethodDetailModal;